/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSwiper.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function setSwiper() {
    const option = { loop: true, speed: 1500, };
    const newsOption = { slidesPerView: "auto", spaceBetween: 20, breakpoints: { 834: { spaceBetween: 32, }, }, navigation: { prevEl: '.post-slider-tool__prev.--news-prev', nextEl: '.post-slider-tool__next.--news-next', } }
    const voiceOption = { slidesPerView: "auto", centeredSlides: true, spaceBetween: 20, breakpoints: { 834: { spaceBetween: 32, }, }, navigation: { prevEl: '.post-slider-tool__prev.--voice-prev', nextEl: '.post-slider-tool__next.--voice-next', } }
    const diaryOption = { slidesPerView: "auto", spaceBetween: 20, breakpoints: { 834: { spaceBetween: 32, }, }, navigation: { prevEl: '.post-slider-tool__prev.--diary-prev', nextEl: '.post-slider-tool__next.--diary-next', } }
    let autoPlayInit = { disableOnInteraction: false, delay: 3000, };
    let pyTargetSlider__news = 0, pyTargetSlider__voice = 0, pyTargetSlider__diary = 0;

    const Swiper__news = () => {
        let length = document.querySelectorAll('.--post-news .swiper-slide').length;
        let targetSlider__news = document.querySelector('.--post-news');
        if (length > 1) {
            const newsSwiper = new Swiper(".--post-news", Object.assign(option, newsOption));
            pyTargetSlider__news = (targetSlider__news.getBoundingClientRect().top + window.pageYOffset) / 2;

            window.addEventListener('scroll', () => {
                if (window.pageYOffset > pyTargetSlider__news) newsSwiper.autoplay.start(Object.assign(autoPlayInit));
            });
        }
    }

    const Swiper__voive = () => {
        let length = document.querySelectorAll('.--post-voice .swiper-slide').length;
        let targetSlider__voice = document.querySelector('.--post-voice');
        if (length > 1) {
            const voiceSwiper = new Swiper(".--post-voice", Object.assign(option, voiceOption));
            pyTargetSlider__voice = (targetSlider__voice.getBoundingClientRect().top + window.pageYOffset) / 2;

            window.addEventListener('scroll', () => {
                if (window.pageYOffset > pyTargetSlider__voice) voiceSwiper.autoplay.start(Object.assign(autoPlayInit));
            });
        }
    }

    const Swiper__diary = () => {
        let length = document.querySelectorAll('.--post-diary .swiper-slide').length;
        let targetSlider__diary = document.querySelector('.--post-diary');
        if (length > 1) {
            const diarySwiper = new Swiper(".--post-diary", Object.assign(option, diaryOption));
            pyTargetSlider__diary = (targetSlider__diary.getBoundingClientRect().top + window.pageYOffset) / 2;

            window.addEventListener('scroll', () => {
                if (window.pageYOffset > pyTargetSlider__diary) diarySwiper.autoplay.start(Object.assign(autoPlayInit));
            });
        }
    }

    Swiper__news();
    Swiper__voive();
    Swiper__diary();
}

export { setSwiper }